import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import {
    ProjectFeedFeedbackFilter,
    PROJECT_FEED_FEEDBACK_FILTER_OPTIONS,
} from '../../lib/projectPaperFeedback';
import ProjectFeedFilterPills, {
    ProjectFeedFilterPillOption,
} from './ProjectFeedFilterPills';

interface ProjectFeedFilterBlockProps {
    feedbackFilter: ProjectFeedFeedbackFilter;
    onFeedbackFilterChange: (filter: ProjectFeedFeedbackFilter) => void;
    compact?: boolean;
}

export default function ProjectFeedFilterBlock({
    feedbackFilter,
    onFeedbackFilterChange,
    compact = false,
}: ProjectFeedFilterBlockProps) {
    const feedbackOptions = useMemo(
        () => PROJECT_FEED_FEEDBACK_FILTER_OPTIONS
            .filter((filter) => filter.value !== 'all')
            .map((filter) => ({
                value: filter.value,
                label: filter.label,
                icon: filter.icon,
                tone: filter.activeTone || 'default',
            })) as ProjectFeedFilterPillOption<ProjectFeedFeedbackFilter>[],
        []
    );

    return (
        <View style={styles.container}>
            <ProjectFeedFilterPills
                options={feedbackOptions}
                selectedValue={feedbackFilter}
                onChange={onFeedbackFilterChange}
                clearValue="all"
                toggleToClear={true}
                compact={compact}
            />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        gap: 10,
    },
});
